
export default {
	props: {
		isHeadingIndex: {
			type: Boolean,
			default: false
		}
	}
}
